import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PlaybackLoadingData {
  title?: string;
  message?: string;
  hint?: string;
}

/** Simple spinner dialog shown while playback data is fetched (design image 4). */
@Component({
  selector: 'app-playback-loading',
  templateUrl: './playback-loading.component.html',
  styleUrls: ['./playback-loading.component.scss'],
})
export class PlaybackLoadingComponent {
  title: string;
  message: string;
  hint: string;

  constructor(@Inject(MAT_DIALOG_DATA) data: PlaybackLoadingData) {
    this.title   = data?.title   ?? 'Historical Playback';
    this.message = data?.message ?? 'Loading playback data...';
    this.hint    = data?.hint    ?? 'This may take a few moments';
  }
}
